import React from "react";

export default function TravelerEditor({ editingId, draft, setDraft, onSave, onCancel }) {
  return (
    <section className="tw-editor">
      <h2 className="tw-editorTitle">
        {editingId === "NEW" ? "Nouvelle card" : "Modifier la card"}
      </h2>

      <div className="tw-grid2">
        <label className="tw-field">
          <span>Titre</span>
          <input
            className="tw-input"
            value={draft?.title || ""}
            onChange={(e) => setDraft((d) => ({ ...d, title: e.target.value }))}
            placeholder="Ex: Famille Durand"
          />
        </label>

        <label className="tw-field">
          <span>Sous-titre</span>
          <input
            className="tw-input"
            value={draft?.subtitle || ""}
            onChange={(e) => setDraft((d) => ({ ...d, subtitle: e.target.value }))}
            placeholder="Ex: Croisière • Juin 2026"
          />
        </label>
      </div>

      <div className="tw-grid2">
        <label className="tw-field">
          <span>Photo (URL)</span>
          <input
            className="tw-input"
            value={draft?.photo?.url || ""}
            onChange={(e) =>
              setDraft((d) => ({ ...d, photo: { ...(d?.photo || {}), url: e.target.value } }))
            }
            placeholder="https://..."
          />
        </label>

        <label className="tw-field">
          <span>Alt (accessibilité)</span>
          <input
            className="tw-input"
            value={draft?.photo?.alt || ""}
            onChange={(e) =>
              setDraft((d) => ({ ...d, photo: { ...(d?.photo || {}), alt: e.target.value } }))
            }
            placeholder="Ex: coucher de soleil sur la mer"
          />
        </label>
      </div>

      <div className="tw-grid3">
        <label className="tw-field">
          <span>Facebook (optionnel)</span>
          <input
            className="tw-input"
            value={draft?.links?.facebook || ""}
            onChange={(e) =>
              setDraft((d) => ({ ...d, links: { ...(d?.links || {}), facebook: e.target.value } }))
            }
            placeholder="https://facebook.com/..."
          />
        </label>

        <label className="tw-field">
          <span>Instagram (optionnel)</span>
          <input
            className="tw-input"
            value={draft?.links?.instagram || ""}
            onChange={(e) =>
              setDraft((d) => ({ ...d, links: { ...(d?.links || {}), instagram: e.target.value } }))
            }
            placeholder="https://instagram.com/..."
          />
        </label>

        <label className="tw-field">
          <span>Polarsteps (optionnel)</span>
          <input
            className="tw-input"
            value={draft?.links?.polarsteps || ""}
            onChange={(e) =>
              setDraft((d) => ({
                ...d,
                links: { ...(d?.links || {}), polarsteps: e.target.value },
              }))
            }
            placeholder="https://www.polarsteps.com/..."
          />
        </label>
      </div>

      <div className="tw-editorFooter">
        <button className="tw-btn" type="button" onClick={onSave}>
          Enregistrer
        </button>
        <button className="tw-btn tw-btnGhost" type="button" onClick={onCancel}>
          Annuler
        </button>
      </div>
    </section>
  );
}
